import { useState, useEffect } from "react";
import StarIcon from "@mui/icons-material/Star";
import StarBorder from "@mui/icons-material/StarBorder";
import "bootstrap/dist/css/bootstrap.min.css";

const StarRating = ({ maxStars, initialRating,value, onRatingChange, disabled }) => {
  const [rating, setRating] = useState(value || 0);

  useEffect(() => {
    if (disabled) {
      setRating(0); // Reset the rating when disabled
    }
  }, [disabled]);

  const handleStarClick = (clickedRating) => {
    setRating(clickedRating);
    if (onRatingChange) {
      onRatingChange(clickedRating);
    }
  };

  const renderStars = () => {
    const stars = [];
    for (let i = 1; i <= maxStars; i++) {
      const filled = i <= rating;
      stars.push(
        filled ? (
          <StarIcon
            key={i}
            onClick={() => handleStarClick(i)}
            sx={{
              cursor: "pointer",
              fill: "#f8c102",
              fontSize: 30,
              marginRight: "5px",
            }}
          />
        ) : (
          <StarBorder
            key={i}
            onClick={() => handleStarClick(i)}
            sx={{
              cursor: "pointer",
              fill: "grey",
              fontSize: 30,
              marginRight: "5px",
            }}
          />
        )
      );
    }
    return stars;
  };

  return <div>{renderStars()}</div>;
};

export default StarRating;
